import type { CapabilityDefinition, CapabilityId, CapabilityCategory } from './types'

const _capabilities = new Map<CapabilityId, CapabilityDefinition>()

export const CAPABILITY_REGISTRY = {
  register(def: CapabilityDefinition): void {
    _capabilities.set(def.id, def)
  },

  get(id: CapabilityId): CapabilityDefinition | undefined {
    return _capabilities.get(id)
  },

  getAll(): CapabilityDefinition[] {
    return [..._capabilities.values()]
  },

  getByCategory(category: CapabilityCategory): CapabilityDefinition[] {
    return [..._capabilities.values()].filter((c) => c.category === category)
  },

  has(id: CapabilityId): boolean {
    return _capabilities.has(id)
  },
} as const
